
export interface IHelpContent {
    url: string;
}

export const HelpContent = (props:IHelpContent) => {

    return <iframe src={props.url} style={{width:"100%", height:"100%"}}/>

}